import { useState} from "react";
import {CommonDialogBox} from "components";
import { Button, DialogProps } from '@mui/material';
import TextField from '@mui/material/TextField';
import * as Utils from "services/UtilsService";
import AuthService from "services/AuthService";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import jwtService from 'services/jwtService';
import { closeDialogUpgrade } from "store/main/userSettingsDialog";

import NotificationModel from 'components/notificationPanel/model/NotificationModel';
import { addNotification } from 'components/notificationPanel/store/dataSlice';



const UpgradeContact = () => {
    const dispatch = useDispatch();
    const upgradeState = useSelector((state:RootState) => state.main.settings.upgradeState)
    const [comment, setComment] = useState(`Dear VoxelSpace,\n\nI would like to upgrade my Plan. Please let me know the steps required to proceed, including any changes in pricing or terms.\n\nLooking forward to your confirmation.\n\nBest regards,\n${AuthService.userEmail}\n${AuthService.userName.toUpperCase()}`);
    //const [email, setEmail] = useState(AuthService.userEmail);
    const subject = 'Request to Upgrade My Plan';

    // const handleEmail = (email:string) => {
    //     setEmail(email)
    //     if(!Utils.validateEmail(email)){
    //         return false
    //     }
    // }

    const handleComment = (comment:string) => {
        setComment(comment)
    }

    const submitUser = async () => {
        if(comment === ''){
            return false
        }
        const endpoint = process.env.REACT_APP_BASE_URL + '/upgrade/contact';
        try{
            let response = await jwtService.fetchRequest({
                method: 'POST',
                url: endpoint,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                data: {
                    email : AuthService.userEmail, comment : comment, subject : subject, key_id : process.env.REACT_APP_BASE_APIKEY
                }
            });

            if(response.data) {
                if (response.data.error === false) {
                    dispatch(addNotification(NotificationModel({ message: 'Thank you! Your message has been sent successfully. We will respond shortly.', options: { variant: 'success' } })));
                    dispatch(closeDialogUpgrade())
                } else {
                    dispatch(addNotification(NotificationModel({ message: 'We encountered an issue while sending your message. Please try again later or contact support.', options: { variant: 'error' } })));
                }
            }else{
                dispatch(addNotification(NotificationModel({ message: 'We encountered an issue while sending your message. Please try again later or contact support.', options: { variant: 'error' } })));
            }
           
        }catch(error){
            console.error(error);
            dispatch(addNotification(NotificationModel({ message: 'We encountered an issue while sending your message. Please try again later or contact support.', options: { variant: 'error' } })));
        }
    }

      
    const closeComposeDialog: DialogProps["onClose"] = (event, reason) => {
        dispatch(closeDialogUpgrade())
    }

    const DialogAction = () => {
        return (
            <div style={{padding: '0 15px'}}>
               
                <Button 
                    type="submit" 
                    onClick={submitUser}  
                    variant="contained"
                    color="primary"
                    sx={{
                        '&.Mui-disabled': {
                            backgroundColor: (theme) => theme.palette.background.default,
                            color: (theme) => theme.palette.text.disabled,
                            opacity: '.75'
                        },
                    }}
                >
                    Submit
                </Button>
            </div>
        )
    }

    return (
        <CommonDialogBox
            classes={{
                paper: 'm-24 rounded-8'
            }}
            open={upgradeState}
            handleClose={closeComposeDialog}
            fullWidth
            maxWidth="sm"
            subtitle1={subject}
            titleh5=''
            dialogAction={<DialogAction />}
            displayScrollBar={true}
            maxHeight={600}
        >
           
            {/* <TextField
                required
                margin="dense"
                id="email"
                name="email"
                label="Email Address"
                type="email"
                fullWidth
                color='primary'
                variant="outlined"
                value={email}
                onChange={e => handleEmail(e.target.value)}
            /> */}
            <TextField
                required
                margin="dense"
                id="comment"
                name="comment"
                label="comment"
                type="text"
                multiline
                rows={15} 
                fullWidth
                value={comment}
                color='primary'
                variant="outlined"
                onChange={e => handleComment(e.target.value)}
            />                        
        </CommonDialogBox>   
    );
};

export default UpgradeContact;
